import type { EChartsTheme } from '../types';

export const buildLegendConfig = (show: boolean, theme: EChartsTheme) =>
  show
    ? {
        show: true,
        type: 'scroll' as const,
        bottom: 0,
        textStyle: { color: theme.textColor, fontSize: theme.fontSize },
      }
    : { show: false };
